import { gql } from '@apollo/client'

// export const CREATE_ORGANIZATION = gql`
// mutation(
//     $code: String!
//     $name: String!
//     $orgUrl: String!
//     $logoUrl: String
//     $currency: String
//     $accountType: AccountType!
//     $activeMetrics: [Metrics!]!
//     $activeBiodiversityVersions: [String!]!
//     $bidVersion: String! #Default to version 3.0
//     $activeCarbonModels: [String!]!
//     $activeHabitatClassifications: JSON!
//     $habitatClassification: String!
//     $baselineYear: Int
//     $hidePostCode: Boolean
//     $showHabitatCode: JSON!
//     $biodiversityPrice: Int
//     $opportunityColumn: Boolean
//     $carbonMetricVersion: String
//     $showSitesInProximity: Boolean
//     $activeDesignatedSites: [String]
//     $createDefaultUser: Boolean
//     $businessUnits: [BusinessUnitInput!]
// ) {
//   createOrganization(
//     input: {
//     code: $code
//     name: $name
//     orgUrl: $orgUrl
//     logoUrl: $logoUrl
//     currency: $currency
//     accountType: $accountType
//     activeMetrics: $activeMetrics
//     activeBiodiversityVersions: $activeBiodiversityVersions
//     bidVersion: $bidVersion
//     activeCarbonModels: $activeCarbonModels
//     activeHabitatClassifications: $activeHabitatClassifications
//     habitatClassification: $habitatClassification
//     baselineYear: $baselineYear
//     hidePostCode: $hidePostCode
//     showHabitatCode: $showHabitatCode
//     biodiversityPrice: Int #Default to 20000
//     opportunityColumn: Boolean #Default to false
//     carbonMetricVersion: String  #Default to Standard Model
//     showSitesInProximity: Boolean #Default to true
//     activeDesignatedSites: [String] # can be an enum
//     createDefaultUser: Boolean #default to true
//     businessUnits: [BusinessUnitInput!]
//     }
//   ) {
//     code
//     name
//     businessUnits {
//       code
//       name
//     }
//     configuration
//   }
// }
// `

// export const UPLOAD_RESOURCE = gql`
//   mutation ($input: uploadResourceInput!) {
//     uploadResource(input: $input) {
//       id
//       resourceKey
//       versions
//     }
//   }
// `

export const ASSIGN_TASKS_TO_USER = gql`
  mutation ($input: [AssignTaskInput!]) {
    assignTasks(input: $input) {
      id
      resource {
        id
        resourceKey
        versions {
          id
          version
          comments
          createdAt
          updatedAt
          pipelineStatus {
            stage
            status
          }
        }
      }
      assignedToUser {
        id
        isActive
        profile {
          id
          email
          firstName
          lastName
          mobile
        }
        groups {
          id
          name
          description
        }
        roles {
          id
          name
          description
          isActive
        }
        userPermissions {
          id
          name
          description
          createdAt
        }
        applications {
          id
          name
          description
          clients {
            id
            name
            description
          }
        }
      }
      assignedToGroup {
        id
        name
        description
      }
      locked
      createdAt
      updatedAt
    }
  }
`
